import { noop } from '@kofno/piper';
import { Cancel, Task } from 'taskarian';
import LearningCollectionEditStore from '..';
import { callApi } from '../../../../../../Appy';
import { currentUserStore } from '../../../../../../CurrentUserStore';
import { findLinkT } from '../../../../../../LinkyLinky';
import { Link } from '../../../../../../Resource/Types';
import { learningCollectionResourceDecoder } from '../../../../Decoders';
import { LearningCollectionResource } from '../../../../Types';
import { LearningCollectionError } from '../../../Types';
import { LoadingForDeepLinks } from '../Types';
import { URLParser, putQueryParam, toUrlT } from '@execonline-inc/url';
import { SearchParameters } from '../../../../../../ListFilter/Types';

const updateSearchParams = (searchParameters: SearchParameters) => (url: URLParser) =>
  searchParameters.reduce(
    (acc, parameter) => putQueryParam(`deep_links_filter[${parameter.key}]`, parameter.value)(acc),
    url,
  );

const processLink =
  (learningCollectionId: string) =>
  (link: Link): Task<LearningCollectionError, Link> =>
    Task.succeed<LearningCollectionError, string>(learningCollectionId).map((v) => ({
      ...link,
      href: link.href.replace('{learning_collection_id}', `${v}`),
    }));

const buildUrl =
  (state: LoadingForDeepLinks) =>
  (link: Link): Task<LearningCollectionError, Link> =>
    toUrlT(link.href)
      .map(updateSearchParams(state.deepLinksSearchParams))
      .map((url): Link => ({ ...link, href: url.href }));

const deepLink =
  (state: LoadingForDeepLinks) =>
  (links: ReadonlyArray<Link>): Task<LearningCollectionError, Link> =>
    Task.succeed<LearningCollectionError, ReadonlyArray<Link>>(links)
      .andThen(findLinkT('program-deep-link'))
      .andThen(processLink(state.id))
      .andThen(buildUrl(state));

const loadLearningCollection = (
  state: LoadingForDeepLinks,
): Task<LearningCollectionError, LearningCollectionResource> =>
  Task.succeed<LearningCollectionError, ReadonlyArray<Link>>(currentUserStore.links)
    .andThen(deepLink(state))
    .andThen(callApi(learningCollectionResourceDecoder, {}));

const readyStoreForDeepLinks =
  (store: LearningCollectionEditStore) =>
  (resource: LearningCollectionResource): Task<LearningCollectionError, void> =>
    Task.succeed(store.readyDeepLinks(resource));

const loadForDeepLinks = (state: LoadingForDeepLinks, store: LearningCollectionEditStore): Cancel =>
  loadLearningCollection(state).andThen(readyStoreForDeepLinks(store)).fork(store.loadError, noop);

export default loadForDeepLinks;
